console.log('Custom scripts loaded');

function fillHidden(hiddenname) {
  var checkboxes = document.querySelectorAll('[hidden-data="'+hiddenname+'"]');
  var hiddenfield = document.getElementById(hiddenname);
  hiddenfield.value = ""
  var i;
  for (i = 0; i < checkboxes.length; i++) {
    var x = checkboxes[i];
    if(x.checked){
      if(hiddenfield.value==""){
        hiddenfield.value = x.value;
      }else{
        hiddenfield.value = hiddenfield.value + ", " + x.value; 
      } 
    }
  }
}

$(window).scroll(function(){
  if($('.cs-product-quantity-box').length > 0) {
    var sectionOffsetTop = $('.cs-product-quantity-box').offset().top;

    if (jQuery(window).scrollTop() >= sectionOffsetTop) {
      $('.cs-product-quantity-box').addClass('cs-sticky');
    } else {
      $('.cs-product-quantity-box').removeClass('cs-sticky');
    }
  }
});

if(document.getElementById("engraving-title")) {
  
  let engravingTitle = document.getElementById("engraving-title");
  let engravingCheckbox = document.getElementById('engraving-product');
  let engravingContent = document.getElementById('engraving-content');
  let giftWrapCheckbox = document.getElementById('gift-wrap-product');
  let radioButton = document.getElementById('engraving-property');
  let typeStyleDiv = document.getElementById('type-style-div');
  let typeExampleDiv = document.getElementById('type-example-div');
  let typeStyleLine = document.getElementById('type-style-line');
  let engravingInput = document.getElementById('engraving-hidden');
  let checkboxGroup = document.querySelectorAll('.checkbox-group');
  let beforeMessage = document.getElementById('Before-Message');
  let afterMessage = document.getElementById('After-Message');
  
  engravingCheckbox.addEventListener("click", function() {
    if($("#engraving-content").hasClass("active")) {
        $("#engraving-content").removeClass('active').slideUp();
        $("#engraving-title").removeClass('active');
        $("#engraving-property").val('no');
        $('#type-style').prop('disabled', true);
      	$('#engraving-hidden').prop('checked', false);
        $('#engraving-hidden').prop('disabled', true);
        $('#text').val('');
        $('.check').prop('checked', false);
        $('.check2').prop('checked', false);
        beforeMessage.value = "";
        afterMessage.value = "";
      } else {
        $("#engraving-content").addClass('active').slideDown();
        $("#engraving-title").addClass('active');
        $('#type-style').prop('disabled', false);
        $("#engraving-property").val($('#engraving-price').val());
        $('#engraving-hidden').prop('disabled', false);
        $('#engraving-hidden').prop('checked', true);
        $('#type-style').change(function() {
          let font = $('#type-style option:selected').text();
          let fontFamily = $('#type-style option:selected').attr('data-font');
          let fontTitle = font.split(' ').slice(0, 1).join("");
          setFontFamily();

          $('.font').hide();
          $("#" + fontTitle).show();
        });
      }
  })
  
  $('#gift-wrap-product').on('click', function() {
    var $this = $(this);
    var $giftMessageBox = $('.gift-message-product');
    if ($this.hasClass('active')) {
      $('#gift-wrap-hidden').prop('disabled', true);
      $('#gift-wrap-hidden').prop('checked', false);
      $this.removeClass('active');
      $giftMessageBox
        .slideUp()
        .find('textarea')
        .prop('disabled', true);      
    } else {
      $('#gift-wrap-hidden').prop('disabled', false);
      $('#gift-wrap-hidden').prop('checked', true);
      $this.addClass('active');
      $giftMessageBox
        .slideDown()
        .find('textarea')
        .prop('disabled', false);
    }
  });
  $('.gift-message-product textarea').on('blur', function(){
    var $this = $(this);
    if($this.val() !== ''){
      $this.next('.dummy-placeholder').hide();
    }else{
      $this.next('.dummy-placeholder').show();
    }
  })

  $('[hidden-data]').on('click', function() {
    let $this = $(this);
    let checkType = $this.attr('hidden-data');
    let src = $this.next('img').attr('src');
    let checkVal = $this.val();
    src = src.replace('15x', '40x');

    if ($this.prop("checked")) {
      if (checkType == 'Before-Message') {
        $('#result-example #font-example-before').attr('src', src).css({
          'display' : 'block',
          'margin-right' : '5px',
          'max-width' : '20px'
        });
      } else if(checkType == 'After-Message') {
        $('#result-example #font-example-after').attr('src', src).css({
          'display' : 'block',
          'margin-left' : '5px',
          'max-width' : '20px'
        });
      }
    } else {
      if (checkType == 'Before-Message') {
        $('#result-example #font-example-before').attr('src', src).css({
          'display' : 'none',
          'margin-right' : '0',
          'max-width' : '0'
        });
      } else if(checkType == 'After-Message') {
        $('#result-example #font-example-after').attr('src', src).css({
          'display' : 'none',
          'margin-left' : '0',
          'max-width' : '0'
        });
      }
    }
  })

  function setFontFamily() {
    let fontFamily = $('#type-style option:selected').attr('data-font');
    $('#result-example').css({
      'font-family' : fontFamily,
      'font-size' : '20px',
      'padding' : '15px 0 20px 0'
    })
  }
  setFontFamily();

  $('.view-engraving-wrap button').click(function(){
    $('html,body').animate({
        'scrollTop': $('.product_gallery').offset().top
	},500);
  });
  $('.check').click(function() {
    $('.check').not(this).prop('checked', false);
  });
  
  $('.check2').click(function() {
    $('.check2').not(this).prop('checked', false);
  });
  
  $('.font').hide();
  $('.font-example .font:first-child').show();
  
  $(document).ready(function() {
    if($("#hidden-lp-image").length > 0) {
      var lp_escape = function(str) {
        var new_str = str.replace(new RegExp("\\(", 'g'), "U0026lp;");
        new_str = new_str.replace(new RegExp("\\)", 'g'), "U0026rp;");
        new_str = new_str.replace(new RegExp("&", 'g'), "U0026amp;");
        new_str = new_str.replace(new RegExp("<", 'g'), "U0026lt;");
        new_str = new_str.replace(new RegExp(">", 'g'), "U0026gt;");
        new_str = new_str.replace(new RegExp(",", 'g'), "U002C");
        new_str = new_str.replace(new RegExp("\\.", 'g'), "U002E");
        new_str = new_str.replace(new RegExp("\\[", 'g'), "U005B");
        new_str = new_str.replace(new RegExp("\\]", 'g'), "U005D");
        new_str = new_str.replace(new RegExp("\"", 'g'), "U0022");
        new_str = new_str.replace(new RegExp("'", 'g'), "U0027");
        new_str = new_str.replace(new RegExp("\\*", 'g'), "U002A");
        new_str = new_str.replace(new RegExp("\\+", 'g'), "U002B");
        new_str = new_str.replace(new RegExp("#", 'g'), "U0023");
        new_str = new_str.replace(new RegExp("@", 'g'), "U0040");
        new_str = new_str.replace(new RegExp("\\?", 'g'), "U003F");
        new_str = new_str.replace(new RegExp("!", 'g'), "U0021");
        new_str = new_str.replace(new RegExp("%", 'g'), "U0025");
        new_str = new_str.replace(new RegExp("=", 'g'), "U003D");
        if(new_str == "") new_str = " ";
        return new_str;        
      };
      
      var lp_engraving_length = function() {
        var text_length = $("#text").val().length,
        icon1 = ((typeof $(".check:checked").data('lp') !== "undefined") ? $(".check:checked").data('lp') : ""),
        icon2 = ((typeof $(".check2:checked").data('lp') !== "undefined") ? $(".check2:checked").data('lp') : "");
        if(icon1 != "") text_length++;
        if(icon2 != "") text_length++;

		    if(text_length > 50)
        {
          alert("Your engraving, including symbols, has a maximum length of 50 characters.");
          return false;
        }
        
        return true;
      };

      var lp_engraving = function(text){
        $(".triton-loader-background").show();
        if ($carousel != undefined)
	     $carousel.flickity( 'select', 0 );
        var lp_base = $("#hidden-lp-image").data("lpImage"), engraving_text = lp_escape(text),
            icon1 = ((typeof $(".check:checked").data('lp') !== "undefined") ? $(".check:checked").data('lp') : ""),
            icon2 = ((typeof $(".check2:checked").data('lp') !== "undefined") ? $(".check2:checked").data('lp') : "");
        
        lp_src = lp_base.replace("%7B%7Blp_engraving%7D%7D", engraving_text);
        lp_src = lp_src.replace("%7B%7Blp_seed%7D%7D", 1);
        lp_src = lp_src.replace("%7B%7Blp_font%7D%7D", (engraving_text != "") ? $("#type-style option:selected").data('lp') : "");
        lp_src = lp_src.replace("%7B%7Blp_icon1%7D%7D", icon1);
        lp_src = lp_src.replace("%7B%7Blp_icon2%7D%7D", icon2);
        lp_src = lp_src.replace("eng[ ]","eng[]");
        $("#lp-image").attr('src',lp_src);
        if($('.product_gallery_nav img[data-index="0"]').length > 0) {
          $('.product_gallery_nav img[data-index="0"]').attr('src', lp_src);	
        }	
        if ($("#ajaxload-content .image__container img[data-index='0']").next('.zoomImg').length > 0) {	
          $("#ajaxload-content .image__container img[data-index='0']").next('.zoomImg').attr("src", lp_src);
        }  
        
        setTimeout(function(){
         imageFunctions.zoom('.product_gallery', false);
          $('body').append('<img style="display: none;" id="el-dummy-image" />')

          $("#el-dummy-image").on('load', function() {
              $(".triton-loader-background").hide();
          }).on('error', function() {
              console.log("error loading image");
          }).attr("src", lp_src);
        }, 500);
      };

      var timeout = null;
      $("#text").on("keyup input", function(e) {
        clearTimeout(timeout); 
        timeout = setTimeout(function () {
          if(lp_engraving_length())
          lp_engraving($("#text").val());
        }, 800);
      });
      
      //       $("#text").on("keyup input", function(e) {
      //         if(lp_engraving_length())
      //           lp_engraving($(this).val());
      //       });
      
      $("#engraving-product").on("click", function(e) {
        if($(this).is(":checked"))
          lp_engraving($("#text").val());
        else
        {
          lp_engraving("");   
          $(".check,.check2").prop('checked',false);
        }
      });   
      
      $(".check,.check2").on("click", function(e) {
        if(lp_engraving_length())
	        lp_engraving($("#text").val());
        else
          $(this).prop('checked',false);
      });
      $("#type-style").on("change", function(e) {
        lp_engraving($("#text").val());
      });
    }
    var setGravingText = function(text) {
      if (text != '') {
        $('#result-example span').html(text);
      } else {
        $('#result-example span').html($("#text").attr('placeholder'));
      }
    }
    $("#text").on("keyup input", function(e) {
      setGravingText($("#text").val());
    });
  } );

}


(function() {
  
  $(document).on('click','.sold_out, .disabled:not(.swym-button)', function(){
  	$(document).find('.bis-reset').click()
    
  })
  /*====== Hide Collection Swatches if There is Only One =======*/
  
//    let collectionSwatches = Array.from(document.querySelectorAll('.collection_swatches'));
  var collectionSwatches = Array.prototype.slice.call(document.querySelectorAll(".collection_swatches"));
  //console.log(collectionSwatches);

  if (collectionSwatches) {
    collectionSwatches.forEach(function(swatch) {
      if(swatch.children.length > 1) {
        swatch.style.display = "block";
      }
    })
  };
  
  if(window.innerWidth < 798) {
    $('.sidebar').hide();
    $('.accordion-title').on('click', function() {
      if($('.sidebar').hasClass('active')) {
        $('.sidebar').slideUp();
        $('.sidebar').removeClass('active');
        $('.accordion-title').removeClass('active');
      } else {
        $('.sidebar').slideDown();
        $('.sidebar').addClass('active');
        $('.accordion-title').addClass('active');
      }
    });
  }
  
  jQuery(document).on("click", ".open-mailchimp-popup", function() {
    jQuery(this).parents(".remodal-wrapper").find(".remodal-close").trigger("click");
    jQuery(".embedded-wrapper").fadeIn(500);
    return false;
  });

  jQuery(document).on("click", ".embedded-wrapper-close", function(){
    jQuery(".embedded-wrapper").fadeOut(500);
    return false;
  });
  
  if($(".triton-product-dropdowns").length > 0)
    init_product_dropdowns();
  
})();

function init_product_dropdowns() {
  
  var $container = $(".triton-product-dropdowns");

  var build_tag_query = function(this_container) {
    var tags = "";
    
    $(this_container).find(".custom-drop.active").each(function() {
      tags += $(this).data('tag') + "+";
    });
    
    return tags.slice(0, -1);
  };

  var product_404 = function() {
    alert('Strange. Did not find a product matching that criteria. Please try again.');
  };
  
  var product_change = function(handle, check_available) {
      	$(".triton-loader-background").show();
    	var engraving_text = "Free Engraving";    
    	jQuery.ajax({
            type: 'GET',
            url: "/products/" + handle+".js",
          	dataType: 'JSON',
            success: function(response) {
              
              	if($carousel != undefined)
                $carousel.flickity('destroy');  
              	$('.product_gallery').removeClass('multi-image')
                //$('.product_gallery').removeClass('flickity-enabled')
                //$('.product_gallery').removeClass('is-draggable')
                $('.product_gallery').removeClass('single-image');
              	if(check_available == true) {
                  $("#ajaxload-content span.vendor").css({display: "block"});
				  $("#ajaxload-content .current_price .money").css({display: "block"});
                  $("#ajaxload-content .current_price").find('.sold_out').remove();
                  $("#ajaxload-content .product_form.product_form_options").css({display: "block"});
                } else {
                  $("#ajaxload-content span.vendor").css({display: "none"});
				  $("#ajaxload-content .current_price .money").css({display: "none"});
				  $("#ajaxload-content .current_price").append('<span class="sold_out">Sold Out</span>');
                  $("#ajaxload-content .product_form.product_form_options").css({display: "none"});
                }
                
              	var all_variants = response.variants;
              	var first_select_options = "";

              	for(i=0; i< all_variants.length; i++) {
                  first_select_options += "<option value='"+all_variants[i].title+"' data-price='"+all_variants[i].price+"' data-compare='"+all_variants[i].compare_at_price+"' data-available='"+all_variants[i].available+"'>"+all_variants[i].title+"</option>";
                }
              
              	$("#ajaxload-content .select .single-option-selector").html(first_select_options);
                
              	var second_select_options = "";

              	for(i=0; i< all_variants.length; i++) {
    	           second_select_options += "<option value='"+all_variants[i].id+"' data-price='"+all_variants[i].price+"' data-compare='"+all_variants[i].compare_at_price+"' data-available='"+all_variants[i].available+"' data-sku='"+all_variants[i].sku+"'>"+all_variants[i].title+"</option>";
                }
              
              	$("#ajaxload-content .select .single-option-selector-outer").html(second_select_options);
              
                $("#ajaxload-content .select .single-option-selector-outer").val($("#ajaxload-content .select .single-option-selector-outer option:first").val()).change();

                var prod_tags = response.tags;
              	var src_image_path = generate_image_data_attr(prod_tags);
              
	            if(prod_tags.indexOf('hidden') > -1) {
                    engraving_text = "Engraving (options)";
                }
              
                //$("#ajaxload-content .engraving_string").text(engraving_text);
                var images = response.images;
				var productImages = '';
                if(images.length > 1) {
				   $('.product_gallery').addClass('multi-image');
                   $('.gallery-wrap').addClass('left-thumbnails').removeClass('gallery-arrows--false').addClass('gallery-arrows--true');
                } else {
                  $('.product_gallery').addClass('single-image');
                  $('.gallery-wrap').removeClass('left-thumbnails'); 	
                }
              	var productNav = "<div class=\"product_gallery_nav product-" + response.id + "-gallery-nav\">";
              	var loaderSection = "<div class=\"triton-loader-background\"><div class=\"triton-loader\"></div></div>";
                images.forEach(function (image, index) {
                    productImages += "<div class=\"gallery-cell gallery-cell-active\" data-thumb=\"\" data-title=\"" + response.title + "\" data-image-height=\"1024px\" data-image-width=\"1024px\">\n    <div class=\"image__container\" style=\"max-width:1024px\">\n<a href=\"" + image + "\" data-fancybox=\"" + response.id + "\"><img " + (index == 0 ? "id='lp-image'" : '') + "src=\"" + image + "\" alt=\"" + response.title + "\" class=\"none lazyautosizes lazyload\" data-index=\"" + index + "\" data-image-id=\"\" data-sizes=\"auto\" data-src=\"" + image + "\" />\n</a>\n    </div>\n</div>";
                  	productNav += "<div class=\"gallery-cell gallery-cell-active\" data-title=\"" + response.title + "\"><img\n                src=\"" + image + "\" alt=\"" + response.title + "\" data-index=\"" + index + "\" data-image-id=\"\" data-featured-image=\"\"></div>";
                });
              	productNav += "</div>";
                if($('.product_gallery_nav').length > 0) {
					$('.product_gallery_nav').remove();
                }
				$('#ajaxload-content .product_gallery').html(productImages);
              	if(images.length > 1) {
              		$('#ajaxload-content .product_gallery').after(productNav);
                }  
              	$(".triton-loader-background").hide();
              	$("#ajaxload-content .product_name").html(response.title);
              	$("#ajaxload-content span.vendor").html(response.vendor);
              
                $("#ajaxload-content .current_price .money").html("$"+(response.variants[0].price / 100).toFixed(2));
                var description = response.description.split('<!-- split -->')[1];
                if(description === undefined){
                  description = response.description;
                }
                $("#ajaxload-content .description, .product-bottom-description.description").html(description);
              
                $("#ajaxload-content .was_price").html('').css("display", "none");
                $("#ajaxload-content .sale.savings").html('').hide();
                $("#ajaxload-content .sale_banner_product").hide();
                
                if(response.compare_at_price) {
                  	$("#ajaxload-content .sale_banner_product").show();
                    $("#ajaxload-content .sale.savings").html('You Save (<span class="money">$'+((response.compare_at_price - response.price) / 100).toFixed(2)+'</span>)').show();
	            	$("#ajaxload-content .was_price").html('<span class="money">$'+(response.compare_at_price / 100).toFixed(2)+'</span>').css("display", "inline-block");
                }

              	$("#ajaxload-content .image__container img").attr("alt", response.title);
                
              	$("#ajaxload-content .product_form.product_form_options").data("product", response);
              	$("#ajaxload-content .product_form.product_form_options").attr("id", "product-form-"+response.id);
              	$("#ajaxload-content .product_form.product_form_options").data("product-id", response.id);
                
              	$("#ajaxload-content #line_item_style").val(response.vendor);
              	$("#ajaxload-content .social_buttons .icon-twitter-share").attr("href", "https://twitter.com/intent/tweet?text="+response.title+"&url=https://tritonjewelry.com/products/"+response.handle+"&via=TritonJewelry");
	            $("#ajaxload-content .social_buttons .icon-facebook-share").attr("href", "https://www.facebook.com/sharer/sharer.php?u="+response.handle);
				$("#ajaxload-content .social_buttons .icon-pinterest-share").attr("href", "https://pinterest.com/pin/create/button/?url="+response.handle+"&description="+response.title+"&media="+src_image_path);
				$("#ajaxload-content .social_buttons .icon-gplus-share").attr("href", "https://plus.google.com/share?url=https://tritonjewelry.com/products/"+response.handle);
				$("#ajaxload-content .social_buttons .icon-mail-share").attr("href", "mailto:?subject=Thought you might like "+response.title+"&body=Hey, I was browsing Triton Jewelry and found "+response.title+". I wanted to share it with you.<br>https://tritonjewelry.com/products/"+response.handle);
              	if($('#engraving-product').is(':checked')){
                 $('#engraving-product').trigger('click');
                }
                
              	setTimeout(function(){
                	$('#lp-image').attr('data-lp-image', $('#hidden-lp-image').attr('data-lp-image'));
                	$('#lp-image').attr('src', $('#hidden-lp-image').attr('src'));
                  	$('.product_gallery_nav img[data-index="0"]').attr('src', $('#hidden-lp-image').attr('src'));
                  	productPage.init();
                }, 0);	
              	
              	if(window.innerWidth < 800) {
                  $('html,body').animate({
                      'scrollTop': $('.product_gallery').offset().top
                  },500);
                }
            },
            error: function(XMLHttpRequest, textStatus) {}
        });
      
    	return false;
  };
  
  $(document).on("change", "#ajaxload-content .single-option-selector-outer", function() {
      var currentPrice = $(this).find("option:selected").data("price");
      var comparePrice = $(this).find("option:selected").data("compare");
      var availableCheck = $(this).find("option:selected").data("available");
      
      $("#ajaxload-content .was_price").html('').css("display", "none");
      $("#ajaxload-content .sale.savings").html('').hide();
      $("#ajaxload-content .sale_banner_product").hide();

      let moneyElement = $("#ajaxload-content .current_price .money");
      if ( moneyElement.length ) {
        moneyElement.html("$"+(currentPrice / 100).toFixed(2));
      } else {
        $("#ajaxload-content .current_price").html( "<span class='money'>$" + (currentPrice / 100).toFixed(2) + "</span>" );
      }
      

      if(comparePrice) {
          $("#ajaxload-content .sale_banner_product").show();
          $("#ajaxload-content .sale.savings").html('You Save (<span class="money">$'+((Number(comparePrice) - Number(currentPrice)) / 100).toFixed(2)+'</span>)').show();
          $("#ajaxload-content .was_price").html('<span class="money">$'+(Number(comparePrice) / 100).toFixed(2)+'</span>').css("display", "inline-block");
      }
      
      if(availableCheck == true) {
          $("#ajaxload-content span.vendor").css({display: "block"});
          $("#ajaxload-content .current_price .money").css({display: "block"});
          $("#ajaxload-content .current_price").find('.sold_out').remove();
	      $("#ajaxload-content .action_button.add_to_cart .text").html('Add to Cart');
      	  $("#ajaxload-content .action_button.add_to_cart").attr("disabled", false).removeClass("disabled");
          $("#ajaxload-content .action_button.add_to_cart").show();
          $("#ajaxload-content .sold_outWrap button").hide();
      } else {
          $("#ajaxload-content span.vendor").css({display: "none"});
          $("#ajaxload-content .current_price .money").css({display: "none"});
          $("#ajaxload-content .current_price").find('.sold_out').remove();
          $("#ajaxload-content .current_price").append('<span class="sold_out">Sold Out</span>');
          $("#ajaxload-content .action_button.add_to_cart .text").html('Sold out');
          $("#ajaxload-content .action_button.add_to_cart").attr("disabled", true).addClass("disabled");
          $("#ajaxload-content .action_button.add_to_cart").hide();
          $("#ajaxload-content .sold_outWrap button").show();
      }
  });
  
//   jQuery(document).on("click", ".open-mailchimp-popup", function() {
//       jQuery(this).parents(".remodal-wrapper").find(".remodal-close").trigger("click");
//       jQuery(".embedded-wrapper").fadeIn(500);
//       return false;
//   });
  
//   jQuery(document).on("click", ".embedded-wrapper-close", function(){
//       jQuery(".embedded-wrapper").fadeOut(500);
//       return false;
//   });

   var generate_image_data_attr = function() {
      var targetEl = $(".triton-product-dropdowns:visible .columns");
      var elcmaterial = targetEl.find(".custom-drop.active.data-cmaterial").data("cmaterial") ? targetEl.find(".custom-drop.active.data-cmaterial").data("cmaterial") : "";
      var elDesign = targetEl.find(".custom-drop.active.data-design").data("design") ? targetEl.find(".custom-drop.active.data-design").data("design") : "";
      var elWidth = targetEl.find(".custom-drop.active.data-width").data("width") ? targetEl.find(".custom-drop.active.data-width").data("width") : "";
      var elMetal = targetEl.find(".custom-drop.active.data-metal").data("metal") ? targetEl.find(".custom-drop.active.data-metal").data("metal") : "";
      var elMaterial = targetEl.find(".custom-drop.active.data-material").data("material") ? targetEl.find(".custom-drop.active.data-material").data("material") : "";
    
      var core_material_text = elcmaterial;

      if(elcmaterial == "Titanium") {
        core_material_text = "Black Titanium";
      }

      var attr_path = "https://fgi.liquifire.com/fgi?set=ringSize["+elWidth+"],material["+core_material_text+"],tungColor["+elMetal+"],goldColor["+elMaterial+"],core["+elDesign+"],eng[],engFont[F01],eIcon1[],eIcon2[],seed[2]&call=url[file:main.chain.txt]&sink=format[jpg]";
      var src_path = "https://fgi.liquifire.com/fgi?set=ringSize["+elWidth+"],material["+core_material_text+"],tungColor["+elMetal+"],goldColor["+elMaterial+"],core["+elDesign+"],eng[%7B%7Blp_engraving%7D%7D],engFont[%7B%7Blp_font%7D%7D],eIcon1[%7B%7Blp_icon1%7D%7D],eIcon2[%7B%7Blp_icon2%7D%7D],seed[%7B%7Blp_seed%7D%7D]&call=url[file:main.chain.txt]&sink=format[jpg]";
	  $("#ajaxload-content .image__container img[data-index='0']").attr("src", attr_path);
      if($('.product_gallery_nav img[data-index="0"]').length > 0) {
		$('.product_gallery_nav img[data-index="0"]').attr('src', attr_path);	
      }	
      if ($("#ajaxload-content .image__container img[data-index='0']").next('.zoomImg').length > 0) {	
      	$("#ajaxload-content .image__container img[data-index='0']").next('.zoomImg').attr("src", attr_path);
      }  
      $("#ajaxload-content .image__container img[data-index='0']").data("lp-image", src_path);
      $("#ajaxload-content #hidden-lp-image").data("lp-image", src_path);
      $("#ajaxload-content #hidden-lp-image").attr("src", attr_path);
          
      return src_path;
  }
  
  var product_select = function(this_container) {
    var tag_string = build_tag_query(this_container);
    $.ajax({
      type: "GET",
      url: '/collections/all/' + tag_string + "?view=json_prods",
      success: function(resp) {
        
        var json = JSON.parse(resp);        
        if(json && json.products.length > 0)
          return product_change(json.products[0].handle, json.products[0].available);
        
        return product_404(resp);
      },
      error: product_404
    });
  };
                     
  var setup_handlers = function() {
    $($container).on("click", ".custom-container:not(.open)", function() {
      $(this).parents(".triton-product-dropdowns").find(".custom-container").removeClass("open");
      $(this).closest(".custom-container").addClass('open');
    });
    
    $($container).on("click", ".custom-container.open .custom-head-container", function() {
      $(this).parents(".triton-product-dropdowns").find(".custom-container").removeClass("open");
      $(this).closest(".custom-container").removeClass('open');
    });
    
    $($container).on("click", ".open .custom-drop", function() {
      var $this_container = $(this).closest(".custom-container");
      $(".custom-drop", $this_container).removeClass('active');
      $(this).addClass("active");
      $this_container.toggleClass('open');
      
      var column_index = $(this).parents(".custom-container").index();

      initiate_options_onready(0, column_index);

      product_select($(this).closest(".triton-product-dropdowns"));
    });
  };
  
  var initiate_available_options = function(all_tags) {

    if(all_tags.length > 0) {

      $(".custom-container .custom-drop").not(".active").attr("disabled", true).addClass("disabled");
      var targetEl = $(".triton-product-dropdowns:visible");

      for(i = 0; i < all_tags.length; i++) {
          var full_string = all_tags[i];
          var first_string = full_string.split("-")[0];

          if(first_string == "available") {
              var final_data = full_string.replace("available", "data");
              targetEl.find("."+final_data).attr("disabled", false).removeClass("disabled");
          }
      }
    }
  }
  
  var get_product_filter_data = function(selectedOptions, selectIndex){

    var selectedOptions = selectedOptions;
	var searchedData = [];
	var selectIndex = selectIndex;

    $.each(productObject, function(key,value){
		var i = 0;

      	$.each(selectedOptions, function(k,v){

          	if(selectedOptions[k] != ''){

              	if(value[k].toString().toLowerCase() != selectedOptions[k].toString().toLowerCase()){				
					return false;
				}

              	i++;
			}		
		});

      	if(selectIndex == i){
			searchedData.push(value[selectIndex]);	
		}		
	});	

	return searchedData.filter(get_unique_product_filter_data);
  }

  var get_unique_product_filter_data = function(value, index, self) { 
    return self.indexOf(value) === index;
  }
  
  var initiate_options_onready = function(check_if_ajax, elToStart) {
    var parentEl = $(".triton-product-dropdowns:visible");

    var active_cmaterial = parentEl.find(".data-cmaterial.active").data("cmaterial");
    var based_on_one_array = [active_cmaterial, "", "", "", ""];
    var based_on_one_result = get_product_filter_data(based_on_one_array, 1);
    
    // Based on one condition ------------------------------------------
    if(elToStart < 1) {

      parentEl.find(".data-design").attr("disabled", true).addClass("hidetemp");

      if(based_on_one_result.length > 0) {

        for(i = 0; i < based_on_one_result.length; i++) {

          var design_val = based_on_one_result[i];

          if(design_val){
            parentEl.find(".data-design[data-design='"+design_val+"']").attr("disabled", false).removeClass("hidetemp");
          }
        }
        
        var activeafterCheck = parentEl.find(".data-design.active").data("design");

        if($.inArray(activeafterCheck, based_on_one_result) < 0 && parentEl.find(".data-design[data-design='"+based_on_one_result[0]+"']").length > 0) {
          parentEl.find(".data-design.active").removeClass("active");
          parentEl.find(".data-design[data-design='"+based_on_one_result[0]+"']").attr("disabled", false).removeClass("hidetemp").addClass("active");
        }

      } else {
        parentEl.find(".data-design").removeClass("active");
      }
    }
    
    var active_design = parentEl.find(".data-design.active").data("design");
    var based_on_two_array = [active_cmaterial, active_design, "", "", ""];
    var based_on_two_result = get_product_filter_data(based_on_two_array, 2);
    
    // Based on two condition ------------------------------------------
    if(elToStart < 2) {

      parentEl.find(".data-width").attr("disabled", true).addClass("disabled");

      if(based_on_two_result.length > 0) {

        for(i = 0; i < based_on_two_result.length; i++) {

          var width_val = based_on_two_result[i];

          if(width_val){
            parentEl.find(".data-width[data-width="+width_val+"]").attr("disabled", false).removeClass("disabled");
          }
        }
        
        var activeafterCheck = parentEl.find(".data-width.active").data("width");

        if($.inArray(activeafterCheck.toString(), based_on_two_result) < 0 && parentEl.find(".data-width[data-width='"+based_on_two_result[0]+"']").length > 0) {
          parentEl.find(".data-width.active").removeClass("active");
          parentEl.find(".data-width[data-width='"+based_on_two_result[0]+"']").attr("disabled", false).removeClass("disabled").addClass("active");
        }

      } else {
        parentEl.find(".data-width").removeClass("active");
      }
    }
    
    var active_width = parentEl.find(".data-width.active").data("width");
    var based_on_three_array = [active_cmaterial, active_design, active_width, "", ""];
    var based_on_three_result = get_product_filter_data(based_on_three_array, 3);
    
    // Based on three condition ------------------------------------------
    if(elToStart < 3) {

      parentEl.find(".data-metal").attr("disabled", true).addClass("disabled");

      if(based_on_three_result.length > 0) {

        for(j = 0; j < based_on_three_result.length; j++) {

          var metal_val = based_on_three_result[j];

          if(metal_val) {
            parentEl.find(".data-metal[data-metal="+metal_val+"]").attr("disabled", false).removeClass("disabled");
          }
        }

        var activeafterCheck = parentEl.find(".data-metal.active").data("metal");

        if($.inArray(activeafterCheck, based_on_three_result) < 0 && parentEl.find(".data-metal[data-metal='"+based_on_three_result[0]+"']").length > 0) {
          parentEl.find(".data-metal.active").removeClass("active");
          parentEl.find(".data-metal[data-metal='"+based_on_three_result[0]+"']").attr("disabled", false).removeClass("disabled").addClass("active");
        }

      } else {
        parentEl.find(".data-metal").removeClass("active");
      }
    }
    
    var active_metal = parentEl.find(".data-metal.active").data("metal");
    var based_on_four_array = [active_cmaterial, active_design, active_width, active_metal, ""];
    var based_on_four_result = get_product_filter_data(based_on_four_array, 4);

    // Based on four condition ------------------------------------------
    if(elToStart < 4) {

      parentEl.find(".data-material").attr("disabled", true).addClass("disabled");
      parentEl.find(".data-material").parents(".custom-container").removeClass("exception-active");

      if(based_on_four_result.length > 0) {

        for(k = 0; k < based_on_four_result.length; k++) {

          var material_val = based_on_four_result[k];

          if(material_val){
            parentEl.find(".data-material[data-material="+material_val+"]").attr("disabled", false).removeClass("disabled");
          }
        }
        
        var activeafterCheck = parentEl.find(".data-material.active").data("material");
        

        if($.inArray(activeafterCheck, based_on_four_result) < 0 && parentEl.find(".data-material[data-material='"+based_on_four_result[0]+"']").length > 0) {
          parentEl.find(".data-material.active").removeClass("active");
          parentEl.find(".data-material[data-material='"+based_on_four_result[0]+"']").attr("disabled", false).removeClass("disabled").addClass("active");
        }
        
        if(based_on_four_result[0] == "") {
          parentEl.find(".data-material").removeClass("active").parents(".custom-container").addClass("exception-active");
        }

      } else {
        parentEl.find(".data-material").removeClass("active");
      }
    }
    
   	var wrapperEl = $(".triton-product-dropdowns:visible .custom-container .dropdown-wrapper");
    var totalEl = wrapperEl.find(".data-design").length;
    var toShowEl = wrapperEl.find(".hidetemp").length;

    if((Number(totalEl) - Number(toShowEl)) > 6) {
		wrapperEl.addClass("has-extra");
    } else {
      wrapperEl.removeClass("has-extra");
    }
  }
  
  initiate_options_onready(0,0);

  product_select($("#customize-desktop.triton-product-dropdowns"));
  
  setup_handlers();
}

$(function(){
  $('.promo_msgs-container').slick({  
    autoplay: true,
    autoplaySpeed: 6000,
    slidesToShow: 1,
    arrows: false,
    dots: false,
    fade: true
  });

  //Show more/ show less toggle for collection header copy/description
  $('.read-more-less-link').on('click', function(){
    $(this).closest('.collection_description').toggleClass('expanded');
  })
  // Promo Bar popups
  $('.promo_msg[data-popup-image]').on('click', function(){
    var $this = $(this);
    var image = $this.data('popup-image');
    var link = $this.data('popup-url') === "" ? "javascript:void();" : $this.data('popup-url');
    var altText = $(this).find('p').text();
    var popupHtml = `<div class="promo_bar-popup">
      <span class="overlay overlay-close-pb-popup"></span>
      <div class="popup-content">
        <span class="close-pb-popup">x</span>
        <a href="` + link + `">
          <img src="`+ image + `" alt=`+ altText +`/>
        </a>
      </div>
    </div>`;
    $('body').append(popupHtml);
    $('.promo_bar-popup').fadeIn();
  });

  $(document).on('click', '.close-pb-popup, .overlay-close-pb-popup', function(){
    $(this).closest('.promo_bar-popup').fadeOut();
    $(this).closest('.promo_bar-popup').remove();
  });

  // Adding trigger on zoom icon for pdp gallery slider
  $('.zoom-icon').on('click', function(){
    $('.gallery-cell.gallery-cell-active.is-selected a').click();
  })
});

//material collections
var nextButton = `<img class="slick-next" src="//tritonjewelry.com/cdn/shop/t/475/assets/chevron-circle-right-solid.svg?v=40144265105369834581775569556" alt="next arrow"/>`;
var prevButton = `<img class="slick-prev" src="//tritonjewelry.com/cdn/shop/t/475/assets/chevron-circle-left-solid.svg?v=68077428248666376401775569556" alt="next arrow"/>`;

CuratedCollectionSection = new function () {


  let slickSettingsNode = {
    dots: false,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    nextArrow: nextButton,
    prevArrow: prevButton,
    arrows: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: true
        }
      }
    ]
  }

  let slickSettingsNodeCoasters = {
    dots: false,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    nextArrow: nextButton,
    prevArrow: prevButton,
    arrows: true,
    responsive: [
      {
        breakpoint: 768,
        settings: "unslick"
      }
    ]
  }

  var settings = {
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    mobileFirst: true,
    nextArrow: nextButton,
    prevArrow: prevButton,
    arrows: true,
    responsive: [
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: true
        }
      },
      {
        breakpoint: 798,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: true
        }
      },
      {
        breakpoint: 1050,
        settings: 'unslick' 
      }
    ]
  }

  $('.circles-container').slick(settings);

  $('.carousel-block').each(function(idx) {
    // find ID so each slick instance is run separately.
    //console.log('found - ' + $(this).attr('id'));
    $('#' + $(this).attr('id')).slick(slickSettingsNode);
    

  });

  $('.carousel-block-coasters').each(function(idx) {
    // find ID so each slick instance is run separately.
    //console.log('found - ' + $(this).attr('id'));
    $('#' + $(this).attr('id')).slick(slickSettingsNodeCoasters);
  });

  $(window).resize(function () {
    $('.carousel-block-coasters').each(function() {
      // find ID so each slick instance is run separately.
      //console.log('found - ' + $(this).attr('id'));
      $('#' + $(this).attr('id')).slick(slickSettingsNodeCoasters);
    });
  });
  
  $(window).on('orientationchange', function () {
    $('.carousel-block-coasters').each(function(idx) {
      // find ID so each slick instance is run separately.
      //console.log('found - ' + $(this).attr('id'));
      $('#' + $(this).attr('id')).slick(slickSettingsNodeCoasters);
    });
  });


  var sl =  $('.circles-container');
      
  $(window).on('resize', function() {
    if( $(window).width() < 1050 &&  !sl.hasClass('slick-initialized')) {
          $('.circles-container').slick(settings);
      }
  });




}();